
import Alert from 'vux/src/components/alert/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import XNumber from 'vux/src/components/x-number/index.vue'
import Group from 'vux/src/components/group/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import ButtonTab from 'vux/src/components/button-tab/button-tab.vue'
import ButtonTabItem from 'vux/src/components/button-tab/button-tab-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Box from 'vux/src/components/box/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Badge from 'vux/src/components/badge/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'

import GroupTitle from "vux/src/components/group-title/index";

export default {
directives: {
TransferDom
},
components: {
GroupTitle,
Alert,
ButtonTab,
ButtonTabItem,
Flexbox,
FlexboxItem,
XButton,
Popup,
Group,
XNumber,
Badge,
Loading,
Actionsheet,
XHeader
},
data() {
return {
info: '',
step: 1,
middleBackText2: '天一互联',
totalSelectedProductNumOnPageLoaded: 0,
showLoading: false,
loadingText: '加载中',

isCartEmpty: true,

showChooseBox: false,

list: [],

limitAmountPerOrder: 0,

selectId: 0,

canNotSubmit: false,

firstAlert: true,

productsAmount: {},

agentLeftAmount: 0,

userPrice: 0,

amountPriceMapping: {},
showMenus: false,

minAmount: 0,
menus: [{
label: '个人中心',
value: 'uc'
}],
isAgent: false,
}
},

mounted: function () {
this.$nextTick(function () {
this.getData();
})
},
computed: {
goButton: function () {
return this.$route.params.cateId == 9 ? '库存取货' : '结算';
},

leftBackText2: function () {
let thisID = this.$route.params.cateId;
if (thisID == 7) {
return '护眼水'
}
if (thisID == 6) {
return '护肤水'
}
},

unit: function () {
if (this.$route.params.cateId == 6) {
return '支';
}

if (this.$route.params.cateId == 7) {
return '套';
}

if (this.$route.params.cateId == 10) {
return '份';
}
if (this.$route.params.cateId == 8) {
return '份';
}
return '支';
},

submitBtnText: function () {
console.log(this.isAgent);
let btnText = '提交';
if (this.totalSelectedProductNumOnPageLoaded === 0 && this.totalSelectedProductNum === 0) {
btnText = '关闭';
} else if (this.isAgent && (this.$route.params.cateId == 6 || this.$route.params.cateId == 10)) {
btnText = '仅会员可下单';
this.canNotSubmit = true;
} else {
if ((this.totalSelectedProductNumOnPageLoaded > 0 && this.totalSelectedProductNumOnPageLoaded < this.minAmount) || (this.totalSelectedProductNum < this.minAmount && this.totalSelectedProductNum > 0)) {
btnText = '起订数量为( ' + this.minAmount + '支 )';
this.canNotSubmit = true;
}
}
return btnText;
},
buyModifyBtnText() {
return this.totalSelectedProductNum > 0 ? '修改 ( ' + this.totalSelectedProductNum + ' ' + this.unit + ' )' : '选择产品';
},


maxAmount: function () {
let res = 0;
for (let index in this.productsAmount) {
if (index != this.selectId) {
res = res + this.productsAmount[index]
}
}
return this.agentLeftAmount - res
},

detailForShow: function () {
if (this.list[this.selectId] !== undefined) {
return this.list[this.selectId].detail
}
return ''
},

totalSelectedProductNum: function () {
let res = 0;
for (let index in this.productsAmount) {
res += this.productsAmount[index] - 0
}

return res;
},

smallThumb: function () {
if (this.list.length === 0)
return '';
return this.tianYiWebUrl + this.list[this.selectId]['small_thumb']
},
price: function () {
let count = Object.keys(this.amountPriceMapping).length;
let mapping = [];
for (let c = 0; c < count; c++) {
let item = this.amountPriceMapping[c];
mapping[item.amount] = item.price;
}

if (count > 0) {

let keys = Object.keys(mapping);

let descKeys = keys.sort((a, b) => b - a);
let length = descKeys.length;

let amountPrice = this.userPrice;
for (let i = 0; i < length; i++) {
if (this.totalSelectedProductNum >= descKeys[i]) {
amountPrice = mapping[descKeys[i]];
break
}
}

if (amountPrice === undefined) {
amountPrice = this.userPrice
}
return Math.min(this.userPrice, amountPrice);
} else {
console.log(this.userPrice)
return this.userPrice;
}
},
},
methods: {

getData() {
console.log(this.tianYiWebUrl)
this.$vux.loading.show({
text: '加载中'
});
const url1 = this.tianYiWebUrl + '/wechat/shop/ajaxDetailView';
const url2 = this.tianYiWebUrl + '/wechat/shop/ajaxUserDetailView';

let url = url1;
if (this.$route.params.cateId == 9) {
url = url2;
}

this.$http.get(url, {params: {cateId: this.$route.params.cateId}}).then(res => {
if (res.data.code === 200) {
this.list = res.data.data.products;

this.step = res.data.data.per_hand;
this.selectId = Object.keys(this.list)[0];
this.productsAmount = res.data.data.initData;
this.limitAmountPerOrder = res.data.data.limitAmount;
this.isCartEmpty = res.data.data.isCartEmpty;
this.userPrice = res.data.data.userPrice;
this.agentId = res.data.data.agentId;
this.agentLeftAmount = res.data.data.agentLeftAmount;
this.amountPriceMapping = res.data.data.amountPriceMapping;
this.isAgent = res.data.data.isAgent;
this.minAmount = res.data.data.minAmount;
this.middleBackText2 = document.title = res.data.data.cateName;
this.info = res.data.data.info;

let res2 = 0;
for (let index in this.productsAmount) {
res2 += this.productsAmount[index] - 0
}
this.totalSelectedProductNumOnPageLoaded = res2;
} else if (res.data.code === 404) {
this.$vux.alert.show({
title: '提示',
content: res.data.message
})
}
this.$vux.loading.hide();
});
},
handleClickBuy() {
let alert = false;
let content = '';

/*  */








if (alert === true) {
this.$vux.alert.show({
title: '无法购买产品',
content: content
}
)
} else {
this.showChooseBox = true
}
},
goToProduct(value) {
if (value === 'go6')
this.$router.push('/shop/cate/6')
if (value === 'go7')
this.$router.push('/shop/cate/7')
},

setSelectedProductId(productId) {
this.selectId = productId
},

setNum(num) {


this.productsAmount[this.selectId] = num - 0
if (this.totalSelectedProductNum > this.agentLeftAmount) { //如果超过了

this.productsAmount[this.selectId] -= num - 0

this.$vux.alert.show({
title: '不能添加更多了',
content: '您的代理此商品库存用完了'
});
}
},

submitToCart() {

if (this.totalSelectedProductNumOnPageLoaded === 0 && this.totalSelectedProductNum === 0) {
this.showChooseBox = false;
return;
}

this.canNotSubmit = false;

this.showLoading = true;
const url = this.tianYiWebUrl + '/wechat/cart/ajaxSetCart'
this.$http.post(url, {data: this.productsAmount, cateId: this.$route.params.cateId}).then(r => {
if (r.data.code === 200) {

this.loadingText = '提交中';

this.showChooseBox = false;
this.totalSelectedProductNumOnPageLoaded = this.totalSelectedProductNum;
setTimeout(() => {
this.showLoading = false;
}, 100)
} else {

this.canNotSubmit = false;
}
})
},

goToCart() {
this.$router.push('/cart')
},
goToUrl() {
let thisID = this.$route.params.cateId;
if (thisID == 7) {
this.$router.push('/shop/cate/6')
} else if (thisID == 6) {
this.$router.push('/shop/cate/7')
} else {
this.$router.go(-1)
}

},
handleActionSheet(k, v) {
if (k === 'uc') {
this.$router.push('/uc/index')
}
}
},
watch: {
'$route'(to, from) { //直接刷新页面， 不会触发route监控
this.getData();
},

totalSelectedProductNum: function (value, v2) {
if (this.showChooseBox === true) {
this.$vux.toast.text('当前数量' + this.productsAmount[this.selectId] + this.unit)
}









if (this.limitAmountPerOrder > 0 && value > this.limitAmountPerOrder) {
this.canNotSubmit = true;

if (this.firstAlert === true) {
this.$vux.alert.show({
title: '太多啦！',
content: '每单数量不能超过' + this.limitAmountPerOrder,
onHide: () => {
this.firstAlert = false
}
})
}
} else {
this.canNotSubmit = false;
}
}
}
};



// WEBPACK FOOTER //
// ./src/components/shop/Cate.vue